module.exports = __webpack_public_path__ + "img/game03.e903f001.jpg";